export const validateAlphaNumericAll = (alphanum) => {
  var reg = /^[A-Za-z0-9.\-\s!@#$%^'*()=+,]*$/;
  if (reg.test(alphanum)) {
    return true;
  }
  else {
    return false;
  }
}

export const removeSpecialCharacters = (str) => {
  if (!str) {
    return '';
  }
  const pattern = /[^a-zA-Z0-9_\s]/g;
  const cleanStr = str.replace(pattern, '');

  return cleanStr;
};

export function getLocationUrl() {
  try {
    if (window !== window.parent) {
      return window.parent.location.toString();
    }
  } catch (e) {
    console.log('Cross-origin frame detected, using current window location');
  }

  return window.location.toString();
}

export function getUrlObj() {
  const url = getLocationUrl();
  try {
    const urlObj = new URL(url);
    return urlObj;
  } catch (e) {
    console.log('Error parsing URL:', e);
    return '';
  }
}

export const hasAtLeastOneWord = (html) => {
  if (!html) return false;

  const text = html.replace(/<[^>]*>/g, "").trim();
  return text.split(/\s+/).length >= 1;
};


export const handleClearCache = () => {
  const savedReferrer = localStorage.getItem('savedReferrer');
  const savedFavourites = localStorage.getItem('savedFavourites');
  const savedSearches = localStorage.getItem('savedSearches');
  
  localStorage.clear();
  sessionStorage.clear();
  
  if (savedReferrer) localStorage.setItem('savedReferrer', savedReferrer);
  if (savedFavourites) localStorage.setItem('savedFavourites', savedFavourites);
  if (savedSearches) localStorage.setItem('savedSearches', savedSearches);
    window.location.reload();
  };

export * from './isPWAInstalled.js';
export * from './isOnSmallScreen.js';
export * from './userLogged.js';
export * from './getParentsByTagName.js';
export * from './deepMerge.js';
export * from './parseMapToDOM.js';
export * from './logoutCleanUp.js'